import { create } from 'zustand';
import type { Todo } from '@ext-bookmark/shared/types';

interface TodoState {
  todos: Todo[];
  selectedTodo: Todo | null;
  selectedDate: Date | null;
  view: 'month' | 'week' | 'list' | 'timeline';
  
  // Actions
  setTodos: (todos: Todo[]) => void;
  addTodo: (todo: Todo) => void;
  updateTodo: (id: string, updates: Partial<Todo>) => void;
  deleteTodo: (id: string) => void;
  setSelectedTodo: (todo: Todo | null) => void;
  setSelectedDate: (date: Date | null) => void;
  setView: (view: TodoState['view']) => void;
}

export const useTodoStore = create<TodoState>((set) => ({
  todos: [],
  selectedTodo: null,
  selectedDate: new Date(),
  view: 'month',
  
  setTodos: (todos) => set({ todos }),
  addTodo: (todo) => set((state) => ({ todos: [...state.todos, todo] })),
  updateTodo: (id, updates) => set((state) => ({
    todos: state.todos.map((t) => (t.id === id ? { ...t, ...updates } : t)),
  })),
  deleteTodo: (id) => set((state) => ({
    todos: state.todos.filter((t) => t.id !== id),
  })),
  setSelectedTodo: (todo) => set({ selectedTodo: todo }),
  setSelectedDate: (date) => set({ selectedDate: date }),
  setView: (view) => set({ view }),
}));
